module.exports = __webpack_public_path__ + "img/minbannerc.a0b80ca0.png";